<footer class="footer h-100 px-5">
  <div class="d-flex align-items-center justify-content-between h-100">
    <div class="d-flex align-items-center gap-3">
      <img [src]="logoUrl" [alt]="companyName + ' Logo'" class="footer-logo" />
      <h3 class="mb-0 current-year" >&copy; {{ currentYear }}</h3>
    </div>
    <div class="d-flex align-items-center gap-4">
      <a [routerLink]="['/faq/About']"
        >{{ "Footer.ABOUT" | translate }} {{ companyName }}</a
      >
      <a [routerLink]="['/faq/PrivacyPolicy']">{{
        "Footer.PRIVACY_POLICY" | translate
      }}</a>
      <a [routerLink]="['/faq/UsagePolicy']">{{
        "Footer.USAGE_POLICY" | translate
      }}</a>
      <a [routerLink]="['/faq/ShaiaCompliance']">{{
        "Footer.SHARIAA_COMPLIANCE" | translate
      }}</a>
      <a [routerLink]="['/faq/ConflictOfInterest']">{{
        "Footer.CONFLICT_OF_INTEREST_POLICY" | translate
      }}</a>
    </div>
  </div>
</footer>
